const Summary = () => {
    const toolkitEl = document.querySelector(".js-resource-toolkit");
    const cardsEl = document.querySelector(".js-resource-card-game");
    const truefalseEl = document.querySelector(".js-resource-true-false-card-game");
    const roadSignsEl = document.querySelector(".js-resource-road-signs-card-game");
    const summaryTotalEl = document.querySelector(".js-summary-total");
    const selectFieldEls = document.querySelectorAll(".js-resource-select");

    if (summaryTotalEl) {
        // set initial summary total if form select field default values are set
        updateSummaryTotal();
    }

    if (toolkitEl) {
        const toolkitSummary = document.querySelector(".js-summary-toolkit");
        updateSummaryFieldValue(toolkitEl, toolkitSummary);
    }

    if (cardsEl) {
        const cardsSummary = document.querySelector(".js-summary-card-game");
        updateSummaryFieldValue(cardsEl, cardsSummary);
    }

    if (truefalseEl) {
        const cardsSummary = document.querySelector(".js-summary-true-false-card-game");
        updateSummaryFieldValue(truefalseEl, cardsSummary);
    }

    if (roadSignsEl) {
        const cardsSummary = document.querySelector(".js-summary-road-signs-card-game");
        updateSummaryFieldValue(roadSignsEl, cardsSummary);
    }

    /**
     * Updates summary field value to match that of select option for corresponding resource
     * @param {Node} selectEl
     * @param {Node} summaryEl
     */
    function updateSummaryFieldValue(selectEl, summaryEl) {
        // set initial value
        summaryEl.textContent = selectEl.value || "0";

        selectEl.addEventListener("change", (node) => {
            summaryEl.textContent = node.target.value || "0";

            updateSummaryTotal();
        });
    }

    /**
     * Updates summary total based on number of selected resources
     */
    function updateSummaryTotal() {
        let total = 0;

        // loop select fields and update total
        selectFieldEls.forEach((node) => {
            total += parseInt(node.value);
        });

        summaryTotalEl.textContent = total || "0";
    }
};

export default Summary;
